<template>
    <v-layout>
        <v-main>
            <v-container>
                <v-card class="text-h6" style="padding: 1em !important">
                    Hier listen wir Kontakte auf, die wir euch ans Herz legen können 😊
                    <br /><br />
                    <v-card style="max-width: 400px; margin: 1em;">
                        <v-card-title>
                            Zucht: Nova Scotia
                        </v-card-title>
                        <v-card-text>
                            Nova Scotia's Maine Coon Cattery ist die Zucht von Stefanie Borowski.
                            Stefanie hat uns unsere <router-link to="/crew/siri">Sirona</router-link> anvertraut und uns von Anfang an als Mentorin begleitet.
                            <br />
                            <v-btn href="https://www.novascotias-mainecoons.de/" style="margin-top: 1em">Nova Scotia Besuchen</v-btn>
                        </v-card-text>
                    </v-card>
                    <v-card style="max-width: 400px; margin: 1em;">
                        <v-card-title>
                            Zucht: Blue Erftpaws
                        </v-card-title>
                        <v-card-text>
                            Maine Coon of Blue Erftpaws ist die Zucht von Tanja Schnitzler.
                            Aus einem Treffen auf Fortbildungen ist eine echte Freundschaft entstanden.
                            Tanja führt eine sehr liebevolle Zucht und ist immer für einen fachlichen Austausch zu begeistern 😊
                            <br />
                            <v-btn href="https://www.maine-coon-of-blue-erftpaws.de/" style="margin-top: 1em">Blue Erftpaws Besuchen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-container>
        </v-main>
    </v-layout>
</template>